import { useMemo } from "react";
import { compareHoldingPermissions } from "../../permissions";
import { isMemberRole } from "../../roles";
import { State } from "../../state";
import * as hooks from "../hooks";

export function useMemberUsers(users: State["users"], filter: string) {

    const members = useMemo(() => users.edits.filter(u => isMemberRole(u.holdingRole) && (!u.deleted)), [users])

    const select = (u: typeof members[number]) => ({
        name: u.displayName,
        email: u.email,
        shouldRetain: !compareHoldingPermissions(u.holdingPermissions, u.initialState.holdingPermissions)
    })

    return hooks.useFilteredUsers(members, filter, select)

}
